import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';
import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

@Component({
  selector: 'app-summary-remarks',
  templateUrl: './summary-remarks.component.html',
  styleUrls: ['./summary-remarks.component.css']
})
export class SummaryRemarksComponent implements OnInit, OnDestroy {
  columns: Array<Object>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    this.columns = this.report.SummaryRemarks.columns;
    this.data = this.report.SummaryRemarks.data;
    this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
  }

  ngOnDestroy() {
    this.reloadSubscription.unsubscribe();
  }

  reload() {
    this.data = this.report.SummaryRemarks.data;
    const gridInstance = this.gridContext.getInstance('SummaryRemarks');
    gridInstance.loadData(this.data);
  }
}


// WEBPACK FOOTER //
// ./src/app/summary-remarks/summary-remarks.component.ts